import styled from "styled-components";
import { theme } from "../../../constants/StyledComponents";

export const StyledPanel = styled.div<{
  $isOpen: boolean;
  $width?: number;
  $fullHeight: boolean;
}>`
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 999;
  width: ${({ $isOpen, $width }) =>
    $isOpen ? ($width ? `${$width}px` : "100%") : "0"};
  height: ${({ $fullHeight }) => ($fullHeight ? "100%" : "calc(100% - 72px)")};
  display: flex;
  flex-direction: column;
  background-color: ${theme.colors.white};
  transition: width 0.6s ease;
  border-left: 1px solid ${theme.colors.purple_2};
`;

export const StyledPanelHeader = styled.div`
  padding: 22px 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${theme.colors.purple_2};
  height: 27px;
  flex-shrink: 0;
`;

export const StyledRightComponent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;
